import { render, staticRenderFns } from "./SweetAlertHeader.vue?vue&type=template&id=c375f3b8&scoped=true&"
import script from "./SweetAlertHeader.vue?vue&type=script&lang=js&"
export * from "./SweetAlertHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c375f3b8",
  null
  
)

export default component.exports